<template>
  <div class="d-flex align-center justify-space-between py-6 px-7">
    <div class="d-flex align-center">
      <v-checkbox
        v-model="value.toggleAppActivated"
        :disabled="disabled"
        class="checkbox-app-activated"
        :label="label"
        color="verde-l20"
        :value="true"
        hide-details
      />
    </div>
    <div>
      <div class="box-toggle d-flex justify-center align-center" @click="value.toggleAppExpanded = !value.toggleAppExpanded">
        <mf-icon :key="value.toggleAppExpanded" class="icon-toggle">{{ !value.toggleAppExpanded ? 'expand_more' : 'expand_less' }} </mf-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleChannel',

  props: {
    value: Object,
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    'value.toggleAppActivated'() {
      this.value.toggleAppExpanded = !!this.value.toggleAppActivated
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox-app-activated {
  padding: 0;
  margin: 0;

  ::v-deep .mf-icon {
    color: $cinza-d10;
    font-size: 32px;
  }

  ::v-deep .v-label {
    font-weight: bold;
    font-size: 20px;
    margin-left: 4px;
    color: $cinza-d20;
  }
}

.box-toggle {
  background-color: $cinza-l70;
  border-radius: 6px;
  width: 43px;
  height: 43px;
  cursor: pointer;

  .icon-toggle {
    color: $cinza-l30;
  }
}
</style>
